// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn__htn8R {
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  text-transform: uppercase;
  text-align: center;
  font-style: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  height: 35px;
  border-radius: 0;
  padding: 0px 12px;
  gap: 5px;
  cursor: pointer;
}
.btn__htn8R:focus-within, .btn__htn8R:focus-visible {
  outline: none;
  box-shadow: none;
}
.btn__htn8R:disabled {
  cursor: default;
}

.btnPrimary__VHBhn {
  border: none;
  color: var(--buttons-text-primary);
  background: var(--buttons-surface);
  border-radius: 2px;
}
.btnPrimary__VHBhn:hover {
  background: var(--buttons-hover);
}
.btnPrimary__VHBhn:active {
  background: var(--buttons-focused);
}
.btnPrimary__VHBhn:disabled {
  background: var(--buttons-disable);
}

.btnSecondary__QstpC {
  color: var(--buttons-text-secondary);
  text-decoration: none;
  background-color: transparent;
  border: none;
  padding: 0px;
  height: unset;
}
.btnSecondary__QstpC:hover {
  color: var(--buttons-hover);
}
.btnSecondary__QstpC:active {
  color: var(--buttons-focused);
}
.btnSecondary__QstpC:disabled {
  color: var(--buttons-disable);
}

.btnOutline__brW13 {
  color: var(--buttons-text-secondary);
  text-decoration: none;
  background-color: transparent;
  border: 1px solid var(--buttons-stroke);
  border-radius: 2px;
}
.btnOutline__brW13:hover {
  color: var(--buttons-hover);
  border: 1px solid var(--buttons-hover);
}
.btnOutline__brW13:active {
  color: var(--buttons-focused);
  border: 1px solid var(--buttons-focused);
}
.btnOutline__brW13:disabled {
  color: var(--buttons-disable);
  border: 1px solid var(--buttons-disable);
}

.small__XG9q0 {
  font-size: 12px;
  width: 140px;
  height: 35px;
}

.medium__J6zLd {
  width: 160px;
}

.full__KCl1h {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./../src/components/uikit/Button/style.module.scss"],"names":[],"mappings":"AA4EA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,QAAA;EACA,eAAA;AA3EF;AA6EE;EAEE,aAAA;EACA,gBAAA;AA5EJ;AA+EE;EACE,eAAA;AA7EJ;;AAiFA;EACE,YAAA;EACA,kCAAA;EACA,kCAAA;EACA,kBAAA;AA9EF;AAgFE;EACE,gCAAA;AA9EJ;AAgFE;EACE,kCAAA;AA9EJ;AAgFE;EACE,kCAAA;AA9EJ;;AAkFA;EACE,oCAAA;EACA,qBAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;AA/EF;AAiFE;EACE,2BAAA;AA/EJ;AAiFE;EACE,6BAAA;AA/EJ;AAiFE;EACE,6BAAA;AA/EJ;;AAmFA;EACE,oCAAA;EACA,qBAAA;EACA,6BAAA;EACA,uCAAA;EACA,kBAAA;AAhFF;AAkFE;EACE,2BAAA;EACA,sCAAA;AAhFJ;AAkFE;EACE,6BAAA;EACA,wCAAA;AAhFJ;AAkFE;EACE,6BAAA;EACA,wCAAA;AAhFJ;;AAoFA;EACE,eAAA;EACA,YAAA;EACA,YAAA;AAjFF;;AAoFA;EACE,YAAA;AAjFF;;AAoFA;EACE,WAAA;AAjFF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n@import 'src/assets/variables.scss';\n\n.btn {\n  font-family: 'Roboto', sans-serif;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 14px;\n  text-transform: uppercase;\n  text-align: center;\n  font-style: normal;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: auto;\n  height: 35px;\n  border-radius: 0;\n  padding: 0px 12px;\n  gap: 5px;\n  cursor: pointer;\n\n  &:focus-within,\n  &:focus-visible {\n    outline: none;\n    box-shadow: none;\n  }\n\n  &:disabled {\n    cursor: default;\n  }\n}\n\n.btnPrimary {\n  border: none;\n  color: var(--buttons-text-primary);\n  background: var(--buttons-surface);\n  border-radius: 2px;\n\n  &:hover {\n    background: var(--buttons-hover);\n  }\n  &:active {\n    background: var(--buttons-focused);\n  }\n  &:disabled {\n    background: var(--buttons-disable);\n  }\n}\n\n.btnSecondary {\n  color: var(--buttons-text-secondary);\n  text-decoration: none;\n  background-color: transparent;\n  border: none;\n  padding: 0px;\n  height: unset;\n\n  &:hover {\n    color: var(--buttons-hover);\n  }\n  &:active {\n    color: var(--buttons-focused);\n  }\n  &:disabled {\n    color: var(--buttons-disable);\n  }\n}\n\n.btnOutline {\n  color: var(--buttons-text-secondary);\n  text-decoration: none;\n  background-color: transparent;\n  border: 1px solid var(--buttons-stroke);\n  border-radius: 2px;\n\n  &:hover {\n    color: var(--buttons-hover);\n    border: 1px solid var(--buttons-hover);\n  }\n  &:active {\n    color: var(--buttons-focused);\n    border: 1px solid var(--buttons-focused);\n  }\n  &:disabled {\n    color: var(--buttons-disable);\n    border: 1px solid var(--buttons-disable);\n  }\n}\n\n.small {\n  font-size: 12px;\n  width: 140px;\n  height: 35px;\n}\n\n.medium {\n  width: 160px;\n}\n\n.full {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": `btn__htn8R`,
	"btnPrimary": `btnPrimary__VHBhn`,
	"btnSecondary": `btnSecondary__QstpC`,
	"btnOutline": `btnOutline__brW13`,
	"small": `small__XG9q0`,
	"medium": `medium__J6zLd`,
	"full": `full__KCl1h`
};
module.exports = ___CSS_LOADER_EXPORT___;
